module.exports = __webpack_public_path__ + "static/splendoTeam-43693f2b50d424f6163fac3c045480a8.png";